import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function FeaturedArticles() {
  const featured = articles.filter((a) => [1, 2, 3].includes(a.id));

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
            精选推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
            style={{ fontFamily: "var(--font-heading)" }}>
            热门Po文指南
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto text-sm">
            由专业编辑团队精选的最受欢迎内容，覆盖po文创作的核心领域
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}